<template>
    <div>
        <div :class="{ 'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">
                            {{ title }}
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-user"></i>
                                    </label>
                                    <multiselect
                                        :value="selectedStaff"
                                        label="text"
                                        track-by="staffID"
                                        :options="staffs"
                                        :searchable="true"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        openDirection="below"
                                        :disabled="this.dataID ? true : false"
                                        @select="onStaffChange">
                                        <template slot="option" slot-scope="{ option }">
                                            {{ option.text }}
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="h5">Leave Type</label>
                            <multiselect
                                :value="selectedType"
                                label="type"
                                track-by="typeID"
                                :options="types"
                                :searchable="true"
                                :show-labels="false"
                                :allow-empty="false"
                                openDirection="below"
                                :disabled="this.dataID ? true : false"
                                @select="onTypeChange">
                                <template slot="option" slot-scope="{ option }">
                                    {{ option.type }}
                                </template>
                            </multiselect>
                        </div>

                        <div class="form-group">
                            <label class="h5">Remark</label>
                            <input class="form-control" type="text" v-model="remark" v-bind="this.dataID ? { 'disabled': 'diasbled'} : null">
                        </div>

                        <div class="form-group">
                            <label class="h5">Start Date</label>
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="startDate"
                                :opens="'right'"
                                :singleDatePicker="true"
                                :timePicker="false"
                                :showDropdowns="true"
                                :ranges="false"
                                :always-show-calendars="true"
                                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                                :autoApply="true"
                                :disabled="this.dataID ? true : false"
                                :append-to-body="true"
                                @update="onStartDateSelect">
                            </date-range-picker>
                        </div>

                        <div class="form-group">
                            <label class="h5">End Date</label>
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="endDate"
                                :minDate="endDateMin"
                                :opens="'right'"
                                :singleDatePicker="true"
                                :timePicker="false"
                                :showDropdowns="true"
                                :ranges="false"
                                :always-show-calendars="true"
                                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                                :autoApply="true"
                                :disabled="this.dataID ? true : false"
                                :append-to-body="true"
                                @update="onEndDateSelect">
                            </date-range-picker>
                        </div>

                        <div class="form-group">
                            <label class="h5">Total Days</label>
                            <input class="form-control" type="number" v-model="day" @change="onDayChange" v-bind="this.dataID ? { 'disabled': 'diasbled'} : null">
                        </div>

                        <div class="form-group">
                            <label class="h5">Status</label>
                            <div class="row pl-3 pr-3">
                                <div class="custom-control custom-switch col-4">
                                    <input type="radio" class="custom-control-input" id="status-pending" value="pending" v-model="status"
                                        v-bind="statusPendingDisable">
                                    <label class="custom-control-label" for="status-pending">Pending</label>
                                </div>
                                <div class="custom-control custom-switch col-4">
                                    <input type="radio" class="custom-control-input" id="status-reject" value="rejected" v-model="status"
                                        v-bind="statusRejectDisable">
                                    <label class="custom-control-label" for="status-reject">Reject</label>
                                </div>
                                <div class="custom-control custom-switch col-4">
                                    <input type="radio" class="custom-control-input" id="status-approve" value="approved" v-model="status"
                                        v-bind="statusApproveDisable">
                                    <label class="custom-control-label" for="status-approve">Approve</label>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <div class="row w-100 no-gutters">

                            <div v-if="dataID" class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-danger waves-effect waves-themed mr-2"
                                    @click="showDeleteModal(dataID)">
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>

                            <div class="col">
                            </div>

                            <div class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-secondary waves-effect waves-themed"
                                    @click="toggleModal = false">
                                    {{ $t('button_link.cancel') }}
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary waves-effect waves-themed ml-2"
                                    @click="submitForm"
                                    :disabled="saveable">
                                    Save
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>
    </div>
</template>
<script>
import moment from 'moment'
import DeleteModal from './../../Delete_Modal.vue'
import DateRangePicker from 'vue2-daterange-picker'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'ConsentFormForm',
    props: {
        isEdit: Boolean
    },
    components: {
        DateRangePicker,
        DeleteModal,
    },
    data() {
        return {
            toggleModal: false,

            title: '',
            saveable: false,

            staffsAll: [],
            staffsFiltered: [],
            staffs: [],
            types: [],

            statusPendingDisable: {},
            statusApproveDisable: {},
            statusRejectDisable: {},

            dataID: 0,
            selectedStaff: {},
            selectedType: {},
            remark: '',
            startDate: {},
            endDate: {},
            endDateMin: null,
            day: '',
            status: '',
        }
    },
    methods: {
        setStaffList(staffs) {
            this.staffsAll = staffs
            this.staffsFiltered = staffs.filter(k => k['enable'] && !k['deleteDate'])
        },
        setStaff(staff) {
            if(!staff || !staff['staffID']) {
                return
            }
            this.selectedStaff = staff
        },
        setLeaveTypes(types) {
            this.types = types
            this.selectedType = types[0]
        },

        showModal(data) {
            this.toggleModal = true

            if (data) {
                this.title = 'Edit Leave Request'

                this.dataID = data['applicationID']
                this.startDate = { startDate: moment.unix(data['startDate']), endDate: moment.unix(data['startDate']) }
                this.endDate = { startDate: moment.unix(data['stopDate']), endDate: moment.unix(data['stopDate']) }
                this.selectedType = this.types.find(k => k['typeID'] === data['typeID'])
                this.day = Math.floor(moment.duration(moment.unix(data['stopDate']).diff(moment.unix(data['startDate']))).asDays()) + 1
                this.status = data['approvedDate'] ? 'approved' : (data['rejectedDate'] ? 'rejected' : 'pending')

                this.statusPendingDisable = { 'disabled' : 'disabled' }
                this.statusApproveDisable = this.status === 'pending' ? {} : { 'disabled' : 'disabled' }
                this.statusRejectDisable = this.status === 'pending' ? {} : { 'disabled' : 'disabled' }

                this.staffs = this.staffsAll
                this.selectedStaff = this.staffsAll.find(k => k['staffID'] === data['staffID']) || null

                return
            }

            this.title = 'Add Leave Request'

            this.dataID = 0
            this.selectedType = {}
            this.remark = ''
            this.startDate = { startDate: null, endDate: null }
            this.endDate = { startDate: null, endDate: null }
            this.day = ''
            this.status = 'pending'

            this.staffs = this.staffsFiltered

            this.statusPendingDisable = {}
            this.statusApproveDisable = {}
            this.statusRejectDisable = {}
        },
        closeModal(isError) {
        },

        onStaffChange(val) {
            this.selectedStaff = val
        },
        onStartDateSelect(val) {
            if (this.endDate.endDate) {
                let start = moment(this.startDate.startDate)
                let end = moment(this.endDate.endDate)
                
                if(start.unix() > end.unix()) {
                    end = moment(start).endOf('day')
                    this.endDate = { startDate: end, endDate: end }
                }

                let duration = moment.duration(end.diff(start))
                this.day = Math.floor(duration.asDays()) + 1
            } else if (this.day) {
                let temp = moment(this.startDate.startDate).add(this.day, 'day').endOf('day')
                this.endDate = { startDate: temp, endDate: temp }
            }
        },
        onEndDateSelect(val) {
            if (this.startDate.startDate) {
                let start = moment(this.startDate.startDate)
                let end = moment(this.endDate.endDate)
                
                if(start.unix() > end.unix()) {
                    start = moment(end).startOf('day')
                    this.startDate = { startDate: start, endDate: start }
                }

                let duration = moment.duration(end.diff(start))
                this.day = Math.floor(duration.asDays()) + 1
            } else if (this.day) {
                let temp = moment(this.endDate.endDate).subtract(this.day, 'day').startOf('day')
                this.startDate = { startDate: temp, endDate: temp }
            }
        },
        onDayChange(val) {
            if (this.startDate.startDate) {
                let temp = moment(this.startDate.startDate).add(this.day - 1, 'day').endOf('day')
                this.endDate = { startDate: temp, endDate: temp }
            } else if (this.endDate.endDate) {
                let temp = moment(this.endDate.endDate).subtract(this.day - 1, 'day').startOf('day')
                this.startDate = { startDate: temp, endDate: temp }
            }
        },
        onTypeChange(val) {
            this.selectedType = val
        },

        submitForm() {
            if (this.dataID) {
                this.updateData()
                return
            }

            this.addData()
        },
        addData() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/application',
                headers: { token: $vm.$session.get('token') },
                data: {
                    startDate: moment(this.startDate.startDate).startOf('day').unix(),
                    endDate: moment(this.endDate.startDate).endOf('day').unix(),
                    typeID: this.selectedType['typeID'],
                },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        var message = 'Successfully add leave request'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        if(this.status === 'pending') {
                            this.$emit('onDataChange')
                            return
                        }

                        this.dataID = response.data.application[0].applicationID
                        this.updateData()
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        updateData() {
            if(this.status === 'pending') {
                return
            }

            let action = this.status === 'approved' ? 'approve' : 'reject'

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/application/' + this.dataID + '/' + action,
                headers: { token: $vm.$session.get('token') },
                data: {}
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        var message = 'Successfully update leave request'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showDeleteModal(dataID) {
            this.dataID = dataID
            var title = this.$i18n.t('header.delete_file')
            var message = 'Are you sure you want to delete this leave request?'
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteFile() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/application/' + this.dataID + '/delete',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        this.title = ''

                        var message = 'Successfully delete leave request'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')

                        this.$refs.deleteModal.toggleModal = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}

#start-datepicker__dialog_ {
    display: none !important;
}

#start-datepicker__dialog_.show {
    display: block !important;
}

#end-datepicker__dialog_ {
    display: none !important;
}

#end-datepicker__dialog_.show {
    display: block !important;
}
</style>